import { toFolder } from '../mappers/folder';
export function parseFolders(settings, res) {
  const cursor = res.data.next_offset;
  res.data.results = res.data.results || [];
  res.data.results = res.data.results.filter(item => Boolean(item.folderid));
  res.data = res.data.results.map(function (data) {
    return toFolder(data, settings);
  });
  res.paging = {
    cursor: cursor || null,
    size: null
  };
  return res;
}